<template>
    <div>
        <timetable v-for="(i, index) in timetables" :key="i.index" class="mb-5 wrap white-bg" v-if="i.active === '1'"
                   :editable="false" :timetableId="i.id"
                   :timeObj="formattedTimetableObj[i.id]" :times="times" :days="days" :groups="groups"
                   :timetableName="i.timetable_name"
                   :active=" typeof i.active === 'string' && i.active === 'true' || typeof i.active !== 'string' && i.active"
                   :info="i.info"
        ></timetable>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Timetable from "../timetable/Timetable";
    import {Resize, Scroll} from 'vuetify/es5/directives'


    export default {
        name: "TimetablePage",
        components: {Timetable},
        directives: {
            Resize, Scroll
        },
        computed: {
            ...mapGetters(['getFormattedTimetableObj', 'getTimeObjRows', 'getTimetables']),
            times() {
                let arr = []
                for (let i = 7; i < 24; i++) {
                    arr.push(i + ':00')
                }
                return arr
            }
        },
        data() {
            return {
                timetables: [],
                timeObjRows: [],
                formattedTimetableObj: {},
                days: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
                groups: ['N*', 'F1-F5', 'F1-F3', 'F4, F5', 'E'],
            }
        },
        methods: {
            ...mapActions(['getAllTimetables']),
            returnTimeObjByRefTimetableId(id) {
                return this.timeObjRows.filter((item) => parseInt(item.ref_timetable) === parseInt(id))
            },
        },
        created() {
            if (!(this.getTimetables.length > 0 && this.getTimeObjRows.length > 0 && this.getFormattedTimetableObj)) {
                this.getAllTimetables(() => {
                    this.timetables = this.getTimetables
                    this.timeObjRows = this.getTimeObjRows
                    this.formattedTimetableObj = this.getFormattedTimetableObj
                })
            } else {
                this.timetables = this.getTimetables
                this.timeObjRows = this.getTimeObjRows
                this.formattedTimetableObj = this.getFormattedTimetableObj
            }

        },
        mounted() {
            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)
        }
    }
</script>
